<h2 mat-dialog-title>{{createMode ? 'Create' : 'Update'}} Environment</h2>
<mat-dialog-content class="m-2" [formGroup]="form">
  <div>
    <b>Environment Info</b>
    <div class="flex gap-2 flex-wrap pt-2">
      <mat-form-field subscriptSizing="dynamic" class="">
        <mat-label>Environment</mat-label>
        <input matInput formControlName="environment" />
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic" class="">
        <mat-label>Name</mat-label>
        <input matInput formControlName="environmentName" />
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic" class="">
        <mat-label>Description</mat-label>
        <input matInput formControlName="environmentDescription" />
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic" class="">
        <mat-label>JB Environment Id</mat-label>
        <input matInput formControlName="jbEnvironmentId" />
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic" class="">
        <mat-label>JB Agent Group Id</mat-label>
        <input matInput formControlName="jbAgentGroupId" />
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>
<div class="flex justify-end p-4">
  <button mat-button [mat-dialog-close]="false" class="mr-2">Cancel</button>
  <button [disabled]="form.invalid || (!createMode && form.pristine)" mat-raised-button color="primary" (click)="createOrUpdateEnvironment()">{{createMode ? 'Create' : 'Update'}}</button>
</div>
